export enum EntityParticipantRole {
  admin = "admin",
  member = "member",
}
